module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai626-209ac17c75dcba82a31a8256a1566464.jpg";